import './portal-navigation.scss'

import {
  CompanySettingApi,
  CompanySettingParameterApi,
  CompanySettingParameterQueryDto,
  CompanySettingTranslatedDto,
  ConfigApi,
  MeetingApi
} from '../../metadata/hrnext-performance-service-api'

import { BaseComponent } from '../../common/base-component'
import { Component } from 'vue-property-decorator'
import { Globals } from '../../common/globals'
import Notiflix from 'notiflix'
import { SearchBoxComponent } from './search-box/search-box'
import { createApi } from '../../common'
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog'

@Component({
  template: require('./portal-navigation.pug'),
  props: ['currentUser', 'canAccessAdmin'],
  components: {
    'search-box': SearchBoxComponent,
    'confirmation-dialog': ConfirmationDialogComponent
  }
})
export class PortalNavigationComponent extends BaseComponent {
  currentUser
  canAccessAdmin
  companySettingApi: CompanySettingApi
  meetingApi: MeetingApi
  configApi: ConfigApi
  companySettingParameterApi: CompanySettingParameterApi
  companySettingTranslatedDto: CompanySettingTranslatedDto[] = []
  companySettingParameterQueryDto: CompanySettingParameterQueryDto[] = []
  isChangeYearModalOpen = false
  isRequestMeetingModalOpen = false
  pendingYearOption: any = null

  constructor() {
    super()
    this.companySettingApi = createApi(CompanySettingApi)
    this.meetingApi = createApi(MeetingApi)
    this.companySettingParameterApi = createApi(CompanySettingParameterApi)
    this.configApi = createApi(ConfigApi)
  }

  async created(): Promise<void> {
    await super.created(true)
  }

  toggleHamburger(): void {
    const burger = document.querySelector('.burger')
    const nav = document.querySelector('#main-navbar')

    burger.classList.toggle('is-active')
    nav.classList.toggle('is-active')
  }

  changeOperationYear(): void {
    this.isChangeYearModalOpen = true
  }

  onYearOptionChange(event: Event): void {
    const target = event.target as HTMLSelectElement
    this.pendingYearOption = target.value
    // Reset select to current value immediately to prevent visual change
    target.value = this.selectedYearOption
    this.isChangeYearModalOpen = true
  }

  confirmChangeYear(): void {
    if (this.pendingYearOption !== null) {
      this.selectedYearOption = this.pendingYearOption
      this.pendingYearOption = null
    }
    this.isChangeYearModalOpen = false
    this.processChangeOperationYear()
  }

  closeChangeYearModal(): void {
    this.isChangeYearModalOpen = false
    this.pendingYearOption = null
  }

  processChangeOperationYear(): void {
    this.updateCurrentYear()
    const currentUrl = this.$route.path.toLowerCase()
    if (currentUrl.includes('dashboard')) {
      this.$router.go(0) // to refresh page
    } else {
      this.$router.push('/dashboard')
    }
  }

  goToNotifications(): void {
    this.$router.push('../notifications')
  }

  requestMeeting(): void {
    this.isRequestMeetingModalOpen = true
  }

  async confirmRequestMeeting(): Promise<void> {
    await this.meetingApi.requestMeetingAsync()
    Notiflix.Notify.success(this.$t('pages.employeePerformanceFormEdit.requestMeetingForwarded') as string)
    this.closeRequestMeetingModal()
  }

  closeRequestMeetingModal(): void {
    this.isRequestMeetingModalOpen = false
  }
}
